import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios from '../../redux/axios';

export interface DocumentSeenStampState {
    preremarksData:any,
    stageData: any,
    imagePath: any,
    zeroStage: any,
    cos_seenStamp: any,
    isFetching: boolean,
    isStageDataSuccess: boolean,
    isError: boolean,
    errorMessage: any,
    isInitialAdded: any,
    SignData: any,
    signCount: any,
    isSignSuccess: boolean,
    SignImagePath: any,
}


const initialState: DocumentSeenStampState = {
    preremarksData:[],
    stageData: [],
    imagePath: '',
    zeroStage: [],
    cos_seenStamp: [],
    isFetching: false,
    isStageDataSuccess: false,
    isError: false,
    errorMessage: '',
    isInitialAdded: false,
    SignData: [],
    signCount: 0,
    isSignSuccess: false,
    SignImagePath: '',
};

export const getDocumentSeenStamp: any = createAsyncThunk(
    'documents/getseenstamps',
    async (udata, thunkAPI) => {
        try {
            const { auth }: any = thunkAPI.getState()
            let tokenStr = auth.user.token;
            // let userType = auth.user.userType == 'CHD'?'chd':auth.user.userType == "DD's & AD's"?'DDsAndAds':'clerk';
            let userType = auth.user.userType == 'CHD' ? '/chd' : auth.user.userType == "DD's & AD's" ? '/DDsAndAds' : auth.user.userType == "Clerk" ? '/clerk' : "";
            let response = await axios({
                // url: `/api${userType}/seenStampInitial?processId=${udata}`,
                url: `/api${userType}/minutesStageWise?processId=${udata}`,
                method: 'get',
                //timeout: 8000,
                headers: {
                    //'Content-Type': 'application/json',
                    "Authorization": `Bearer ${tokenStr}`
                }
            })

            let data = response.data;
//console.log(data.data.preremarks,"pre-remarks")
            //code for sorting the users list's .....
            if (data && data.data && data.data.data && data.data.data.length) {
                let chdUsers: any = [];
                let adsUsers: any = [];
                let clerkUsers: any = [];
                let mainData: any = data.data.data;
                if (data.data.zeroStage) {

                    let var_zeroStage = data.data.zeroStage;
                    if (var_zeroStage.userDetail && var_zeroStage.userDetail.length) {
                        var_zeroStage.userDetail[0]['initial'] = var_zeroStage.initial;
                        let particular_user = var_zeroStage.userDetail[0];
                        if (particular_user.userType === "CHD") {
                            chdUsers.push(particular_user);
                        }
                        else if (particular_user.userType === "Clerk") {
                            clerkUsers.push(particular_user);
                        }
                        else { adsUsers.push(particular_user); }
                    }
                }
                for (let index: any = 0; index < mainData.length; index++) {
                    const element: any = mainData[index];
                    if (element.userType === "CHD") {
                        chdUsers.push(element);
                    }
                    else if (element.userType === "Clerk") {
                        clerkUsers.push(element);
                    }
                    else { adsUsers.push(element); }
                }

                data.data.data = [...chdUsers, ...adsUsers, ...clerkUsers]
            }
            if (response.status === 200) {
                return data;
            }
            else if (data.code === 200) {
                return data;
            }
            else {
                return thunkAPI.rejectWithValue(data);
            }
        } catch (err) {
            let error: any = err;
            if (!error.response) {
                throw err
            }

            return thunkAPI.rejectWithValue(error.response.data)
        }
    }
);

export const addInitials: any = createAsyncThunk(
    'documents/seenstampsInitial',
    async (udata, thunkAPI) => {
        try {
            const { auth }: any = thunkAPI.getState()
            let tokenStr = auth.user.token;
            // let userType = auth.user.userType == 'CHD'?'chd':auth.user.userType == "DD's & AD's"?'DDsAndAds':'clerk';
            let userType = auth.user.userType == 'CHD' ? '/chd' : auth.user.userType == "DD's & AD's" ? '/DDsAndAds' : auth.user.userType == "Clerk" ? '/clerk' : "";
            const response = await axios.post(`/api${userType}/seenStampInitial`, udata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

            let data = response.data;
            if (response.status === 200) {
                return data;
            }
            else if (data.code === 200) {
                return data;
            }
            else {
                return thunkAPI.rejectWithValue(data);
            }
        } catch (err) {
            let error: any = err;
            if (!error.response) {
                throw err
            }

            return thunkAPI.rejectWithValue(error.response.data)
        }
    }
);


export const DocumentSeenStampSlice = createSlice({
    name: 'documentseenstamps',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        clearStateSlice: (state, { payload }: PayloadAction) => {
            // state.stageData = [];
            state.isFetching = false;
            state.isStageDataSuccess = false;
            state.isError = false;
            state.errorMessage = '';
            state.imagePath = '';
        },
        unsetInitialAddedSlice: (state, { payload }: PayloadAction) => {
            state.isInitialAdded = false;
            state.errorMessage = '';
        },
        setSignListDetailState: (state, { payload }) => {
            state.SignData = payload.data.data;
            state.signCount = payload.data.count;
            state.SignImagePath = payload.data.path;
            state.isSignSuccess = true;
        },
        unsetSignListDetailState: (state) => {
            // state.SignData = [];
            // state.signCount = 0;
            // state.SignImagePath = '';
            state.isSignSuccess = false;
        },
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: {
        [getDocumentSeenStamp.fulfilled]: (state, { payload }) => {

            state.stageData = payload.data.data;
            state.preremarksData = payload.data.preremarks;
            
            state.imagePath = payload.data.SIGNATURE_URL;
            state.zeroStage = payload.data.zeroStage;
            state.cos_seenStamp = payload.data.cos_seenStamp;
            state.isFetching = false;
            state.isStageDataSuccess = true;
            return state;
        },

        [getDocumentSeenStamp.pending]: (state) => {
            state.isFetching = false;
        },

        [getDocumentSeenStamp.rejected]: (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            if (payload) {
                state.errorMessage = payload.message;
            }
            else {
                state.errorMessage = 'Internal error';
            }
        },

        [addInitials.fulfilled]: (state, { payload }) => {

            if (payload.success == false) state.isError = true;
            else state.isError = false;
            if (payload.success) state.isInitialAdded = true;
            if (payload.message) state.errorMessage = payload.message;
            else state.errorMessage = '';
            return state;
        },

        [addInitials.pending]: (state) => {
            state.isFetching = false;
        },

        [addInitials.rejected]: (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            if (payload) {
                state.errorMessage = payload.message;
            }
            else {
                state.errorMessage = 'Internal error';
            }
        }
    },
});

export const { clearStateSlice, unsetInitialAddedSlice, setSignListDetailState, unsetSignListDetailState } = DocumentSeenStampSlice.actions;

export function clearState() {

    return async (dispatch: any) => {
        dispatch(clearStateSlice());
    };
}

export function unsetInitialAdded() {

    return async (dispatch: any) => {
        dispatch(unsetInitialAddedSlice());
    };
}



export function clearSignatureListState() {

    return async (dispatch) => {
        dispatch(unsetSignListDetailState());
    }
}


// export const addInitials = (bdata: any) => async (dispatch: any, getState: any) => {
//     try {
//         const { auth }: any = getState()
//         let tokenStr: any = auth.user.token;
//         //  let userType:any = auth.user.userType == 'CHD'?'chd':auth.user.userType == "DD's & AD's"?'DDsAndAds':'clerk';
//         let userType: any = auth.user.userType == 'CHD' ? '/chd' : auth.user.userType == "DD's & AD's" ? '/DDsAndAds' : auth.user.userType == "Clerk" ? '/clerk' : "";
//         const response = await axios.post(`/api${userType}/seenStampInitial`, bdata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

//         let data = response.data;
//         dispatch(setInitialAddedSlice());
//         return data;
//     } catch (error) {
//         let err: any = error;
//         return err.response.data;
//     }
// };


export const getSignatureListAsyn = () => async (dispatch, getState) => {
    try {
        const { auth } = getState()
        let tokenStr = auth.user.token;
        let userType = auth.user.userType == 'CHD' ? 'chd' : auth.user.userType == "DD's & AD's" ? 'DDsAndAds' : 'clerk';
        let response = await axios({
            url: `/api/${userType}/signature`,
            method: 'get',
            //timeout: 8000,
            headers: {
                //'Content-Type': 'application/json',
                "Authorization": `Bearer ${tokenStr}`
            }
        })

        let data = response.data;
        dispatch(setSignListDetailState(data));
        return data;
        // console.log(data.data)
        //dispatch(getAllUserDepartments(data));
    } catch (error: any) {
        return error.response.data;
    }
};

export const DocumentSeenStampSelector = (state: any) => state.documentseenstamps;

export default DocumentSeenStampSlice.reducer;
